export default __webpack_public_path__ + "static/media/organization.d66be20a.png";